import React,{ PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import VideoTag from './VideoTag';
import Footer from '../Footer';
import Header from '../Header';

import { homePage, userMenu, videoImage } from '../../../Constants/user';

import './home.scss';

class Home extends PureComponent {
    constructor(props) {
        super(props);
        console.log(props.lang);
        let firstLang = props.lang || 'en';

        props.active(0);

        document.title = homePage.find(el => el.lang === firstLang).title;

        let language = homePage.find(el => el.lang === firstLang);

        this.state = {
            initialized: true,
            lang: props.lang,
            language
        };
    }
    static getDerivedStateFromProps(props) {
        let language = homePage.find(el => el.lang === props.lang);
        document.title = language.title;

        return {
            language,
            lang: props.lang,
            initialized: true,
       }
    }
    render() {
        if (!this.state.initialized) return null;
        const { language: { visionText, mission, missionText } } = this.state;
        const { setLanguage, activeMenu, language, width } = this.props;

        return (
            <div id={'homePage'}>
                <div id={'left'}>
                    {width > 1024 ? (
                        <Link to={'/'}><img src={'/images/userPage/desktop/Logo for web.png'} alt /></Link>
                    ) : (
                        <Link to={'/'}><img src={'/images/userPage/tablet/Logo2.png'} alt /></Link>
                    )}
                </div>
                <div id={'right'}>
                    <Header
                        userMenu={userMenu}
                        language={language}
                        active={activeMenu}
                        setLanguage={setLanguage}
                    />
                    <div id={'container'}>
                        <div id={'containerInner'}>
                            <div id={'textPart'}>
                                <div id={'vision'}>
                                    <div id={'visionTitle'} />
                                    <div id={'visionText'}>{visionText}</div>
                                </div>
                                <br/>
                                <div id={'mission'}>
                                    <div id={'missionTitle'}>{mission}</div>
                                    <div id={'missionText'}>{missionText}</div>
                                </div>
                                <div id={'videoContainer'}>
                                    {videoImage[0] ? (
                                        <VideoTag />
                                    ) : width > 1024 ? (
                                        <img src={'/images/userPage/desktop/' + videoImage[1]} alt />
                                    ) : (
                                        <img src={'/images/userPage/tablet/' + videoImage[2]} alt />
                                    )
                                    }
                                </div>
                            </div>
                            <Footer language={language} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ main: { width } }) => ({
    width,
});

export default connect(mapStateToProps)(Home);
